<p-card class="p-card container">
  <h3 class="text-center" i18n>⚠️ Avis de refus</h3>

  <div class="layout__inner-card flex">
    <div [innerHTML]="refusalNoticeInfo.refusalNotice[refusalNoticeInfo.languageCode] | emMarkdown"></div>
  </div>
</p-card>
